export default "__VITE_ASSET__DY5HdLGW__"